class EventModel {
    static publish(data) {
        PubSub.publish(this.eventName, data);
    }
    static subscribe(callback) {
        return PubSub.subscribe(this.eventName, callback);
    }
}
export default EventModel;
